import React from 'react'

 const PostCard = ({imageUrl,post,fullName}) => {
  return (
    <div className="max-w-xs w-full mx-auto">
      <div
        // className="group cursor-pointer relative h-96 rounded-2xl  shadow-card overflow-hidden bg-cover bg-center flex flex-col justify-end p-5 transition-transform duration-300 hover:-translate-y-2"
        className="cursor-pointer relative h-96 rounded-md shadow-lg overflow-hidden bg-cover bg-center flex flex-col justify-end p-5 transition-transform duration-300 hover:-translate-y-2"
        style={{
          backgroundImage: `url("${imageUrl}")`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent transition-opacity duration-300 group-hover:from-black/95"></div>

        <div className="relative z-10">
          <h1 className="text-xl font-bold text-white">{post}</h1>
          <p className="text-sm text-slate-300 mt-2">
            {fullName}
          </p>
        </div>
      </div>
    </div>
  )
}
export default PostCard